export default {
  title: 'Pagamento',
  description: 'Tutte le transazioni sono sicure e crittografate',
  show_more_payment_methods: 'Mostra altri metodi di pagamento',
  express_checkout_divider: 'oppure',
};
